const cn = {
	language: {
		language: 'EN'
	},
	LOGIN: {
		txt1: 'CorDx - Aiiso QMS',
		txt2: 'Account',
		txt3: 'Please enter User ID',
		txt4: 'Password',
		txt5: 'Please enter your password',
		txt6: 'Log In',
		txt7: 'Email / Account',
		txt8: 'Please enter your email or account',
		txt9: 'Verification Code',
		txt10: 'Please enter the verification code',
		txt11: 'Password Login',
		txt12: 'Verification Code Login',
		txt13: 'Get Code',
		txt14: 'Resend in seconds',
		txt15: 'Invalid email format. Please check your email or switch to password login.',
		txt16: 'Verification code sent successfully',
		txt17: 'Email',
		txt18: 'Please enter User ID',
	},
	CONFIG: {
		txt1: 'CorDx - Aiiso QMS',
		txt2: '修改密码',
		txt3: '配置管理',
		txt4: '一、系统管理员配置',
		txt5: '角色管理：',
		txt6: '添加管理员（授权后台菜单管理权限）',
		txt7: '前往配置>',
		txt8: '二、集团管理（架构&用户&身份）',
		txt9: '业务角色管理：',
		txt10: '创建管理员角色（用户身份分组之一，用于前台上传文件时权限划分）',
		txt11: '前往配置>',
		txt12: '岗位管理：',
		txt13: '创建岗位（用户身份分组之一，用于前台上传文件时权限划分）',
		txt14: '前往配置>',
		txt15: '组织架构管理：',
		txt16: '按需维护组织架构（前台文件夹及文件及后台用户均存储在所属架构下）',
		txt17: '前往配置>',
		txt18: '用户管理：',
		txt19: '按需创建用户，完善用户信息（需配置该用户的所辖站点管理权、用户身份、用户文件/文件夹操作权限）',
		txt20: '前往配置>',
		txt21: '三、集团文件管理',
		txt22: '文件类型管理：',
		txt23: '按需创建文件类型（用于前台上传文件时选择文件分类）',
		txt24: '前往配置>',
		txt25: '文件管理：',
		txt26: '可查看/预览/下载所辖站点下的文件；可根据文件名称/版本号/文件类型/文件状态等筛选条件查找文件',
		txt27: '前往配置>',
		txt28: '四、审批管理',
		txt29: '功能暂未开放',
		txt30: '功能台',
		txt31: '主页',
		txt32: '文件管理',
		txt33: '审批中心',
		txt34: '操作日志',
		txt35: '系统完善中'
	},
	INDEX: {
		txt1: 'CorDx - Aiiso QMS',
		txt2: '新建文件夹',
		txt3: '上传',
		txt4: '搜索文件',
		txt5: '配置/管理',
		txt6: '修改密码',
		txt7: '退出登录',
		txt8: '我的主页',
		txt9: '最近访问',
		txt10: '位置',
		txt11: '全部',
		txt12: '文件夹',
		txt13: '文档',
		txt14: '图片',
		txt15: '其他',
		txt16: '返回',
		txt17: '搜索到 “',
		txt18: '” 共 ',
		txt19: '条',
		txt20: '“',
		txt21: '” 搜索结果：',
		txt22: '名称',
		txt23: '类型',
		txt24: '大小',
		txt25: '日期',
		txt26: '操作',
		txt27: '当前列表为空',
		txt28: '选中文件后显示文件信息',
		txt29: '文件详情',
		txt30: '文件信息',
		txt31: '类型：',
		txt32: '位置：',
		txt33: '所有者：',
		txt34: '大小：',
		txt35: '上次修改时间：',
		txt36: '上次打开时间：',
		txt37: '创建时间：',
		txt38: '文件分类：',
		txt39: '文件版本号：',
		txt40: '操作',
		txt41: '查看',
		txt42: '下载',
		txt43: '打印',
		txt44: '编辑',
		txt45: '更新',
		txt46: '作废',
		txt47: '历史版本',
		txt48: '上传于',
		txt49: '主版本',
		txt50: '操作记录',
		txt51: '努力开发中...',
		txt52: '确定删除该文件夹？',
		txt53: '提示',
		txt54: '确定',
		txt55: '取消',
		txt56: '删除成功',
		txt57: '是否退出登录？',
		txt58: '退出成功',
		txt59: '创建子文件夹',
		txt60: '上传文件',
		txt61: '编辑文件夹',
		txt62: '删除文件夹',
		txt63: '创建者',
		txt64: '转移',
		txt65: '文件编号：'
	},
	ADDEDIT: {
		txt1: '上传文件',
		txt2: '更新文件',
		txt3: '编辑文件',
		txt4: '已选文件',
		txt5: '点击上传',
		txt6: '文件名称',
		txt7: '填写文件名称',
		txt8: '文件编号',
		txt9: '填写文件编号',
		txt10: '版本号',
		txt11: '填写版本号',
		txt12: '文件所属分类',
		txt13: '请选择文件所属分类',
		txt14: '文件描述',
		txt15: '请描述该文件用途或版本优化了哪些内容',
		txt16: '文件授权',
		txt17: '提示：',
		txt18: '默认上传者拥有文件的作废及删除权限；',
		txt19: '查看 / 下载权限',
		txt20: '按部门',
		txt21: '选择部门&站点',
		txt22: '按角色',
		txt23: '按岗位',
		txt24: '按人员',
		txt25: '选择人员',
		txt26: '编辑权限',
		txt27: '更新权限',
		txt28: '取消',
		txt29: '提交',
		txt30: '上传成功',
		txt31: '编辑成功',
		txt32: '更新成功',
		txt33: '请先上传文件',
		txt34: '上传的文件类型不正确，允许的类型有：png,jpg,jpeg,pdf,webp,xls,xlsx,txt,csv,doc,docx,ppt,pptx,zip,mp3,mp4,avi',
		txt35: '暂不支持上传超过10MB的文件！',
		txt36: '此为不可编辑项'
	},
	ADDSITE: {
		txt1: '选择部门&站点',
		txt2: '取消',
		txt3: '确定',
		txt4: '请先选择部门或站点'
	},
	ADDUSER: {
		txt1: '选择人员',
		txt2: '请选择人员',
		txt3: '取消',
		txt4: '确定',
		txt5: '请先选择人员'
	},
	CREATEFOLDER: {
		txt1: '创建新文件夹',
		txt2: '编辑文件夹',
		txt3: '文件夹名',
		txt4: '请输入你的文件夹名称',
		txt5: '创建',
		txt6: '确定',
		txt7: '取消',
		txt8: '创建失败，文件夹已存在 / 创建失败，名称不能为空',
		txt9: '修改成功',
		txt10: '创建成功'
	},
	DEL: {
		txt1: '删除文件',
		txt2: '作废文件',
		txt3: '提示：作废文件保留期限为永久',
		txt4: '已选文件',
		txt5: '文件大小',
		txt6: '文件编号',
		txt7: '原因说明',
		txt8: '请描述删除文件的原因',
		txt9: '请描述作废文件的原因',
		txt10: '取消',
		txt11: '提交',
		txt12: '请描述原因',
		txt13: '作废成功'
	},
	PWD: {
		txt1: 'Change Password on First Login',
		txt2: 'Set Password',
		txt3: 'Please enter your current password',
		txt4: 'Please enter a new password',
		txt5: 'Please confirm your new password',
		txt6: 'Cancel',
		txt7: 'Confirm',
		txt8: 'The new password cannot be the same as the current password.',
		txt9: 'The new password cannot be the default password.',
		txt10: 'The new password and confirmation password do not match.',
		txt11: 'Password has been reset successfully.',
	},
	MOVESITE: {
		txt1: '文件转移',
		txt2: '文件名：',
		txt3: '当前位置：',
		txt4: '请选择要移动的位置：',
		txt5: '请先选择要移动的位置',
		txt6: '转移成功'
	}
};

export default cn